import * as React from 'react';
import ePharmaServices from '../../services/epharma-services';
import { IBeneficiaryCouponRequest, IPersonRequest, IBeneficiaryCouponUpdateRequest, IBeneficiaryRequest } from '../../interfaces/beneficiary';
import ValidatorService from '../../services/validator-service';
import { IStateResponse } from '../../interfaces/state';
import { ISkuResponse } from '../../interfaces/sku';
import ConfigService from '../../services/config-service';
import keys from '../../util/keys';


interface FieldsValidation {
    beneficiaryId: boolean;
    coupom: boolean;
    product: boolean;
    sku: boolean;
    cpf: boolean;
    crmNumber: boolean;
    crmState: boolean;
    bornDateMask: boolean;
    cpfResponsible: boolean;
    bornDateMaskResponsible: boolean;
    agreeTerm: boolean;
    isValidPerson: boolean;
    isValidComprador: boolean;
    [key: string]: boolean;
}

export default function CouponRegisterHook() {
    const [request, setRequest] = React.useState<IBeneficiaryCouponRequest>({
        beneficiaryId: 0,
        coupom: "",
        product: "",
        productId: 0,
        skuId: 0,
        cpf: "",
        crmNumber: "",
        crmState: "0",
        bornDateMask: "",
        bornDate: null,
        cpfResponsible: "",
        bornDateMaskResponsible: "",
        bornDateResponsible: null,
        agreeTerm: 0
    });

    const [fieldsInvalid, setFieldsInvalid] = React.useState<FieldsValidation>({
        beneficiaryId: true,
        coupom: true,
        product: true,
        sku: true,
        cpf: true,
        crmNumber: true,
        crmState: true,
        bornDateMask: false,
        agreeTerm: true,
        cpfResponsible: false,
        bornDateMaskResponsible: false,
        isValidPerson: false,
        isValidComprador: false
    });

    const [personPaciente, setPersonPaciente] = React.useState<IPersonRequest>({
        cpf: '',
        birthDate: ''
    });

    const [personComprador, setPersonComprador] = React.useState<IPersonRequest>({
        cpf: '',
        birthDate: ''
    });

    const [loading, setLoading] = React.useState(false);
    const [loadingCoupon, setLoadingCoupon] = React.useState(false);
    const [loadingPersonValidation, setLoadingPersonValidation] = React.useState(false);
    const [loadingResponsableValidation, setLoadingResponsableValidation] = React.useState(false);
    const [messageInvalidCoupon, setMessageInvalidCoupon] = React.useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);

    const [skus, setSkus] = React.useState<ISkuResponse[]>([] as ISkuResponse[]);
    const [states, setStates] = React.useState<IStateResponse[]>([] as IStateResponse[]);

    const [isValidForm, setIsValidForm] = React.useState(false);
    const [showSucess, setShowSucess] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");

    React.useEffect(() => {
        const fetchData = async () => {
            await getState();
        };

        fetchData();
    }, []);

    const isAdult = (bornDateMask: string) => {
        const data = bornDateMask.split("/");
        const birthDate = new Date(Number(data[2]), Number(data[1]) - 1, Number(data[0]));
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();

        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age >= 18;
    };


    const validateCoupon = async (coupon: string) => {
        if (coupon.length === 15) {
            setLoadingCoupon(true);
            setMessageInvalidCoupon('');
            setSkus([]);
            setRequest(prevState => (
                {
                    ...prevState,
                    product: "",
                }));
            try {

                const baseUrl = window.momentaMaisService.base;
                const verifyCoupomUrl = await ConfigService().getConfig(keys.EndpointMomentaMaisVerifyCoupon);

                const response = await ePharmaServices(baseUrl).get(`${verifyCoupomUrl.replace("{coupom}", coupon)}`);

                if (response.data.success) {

                    if (!response.data.data.skus) {
                        setMessageInvalidCoupon('Benefício não cadastrado');
                        return;
                    }
                    setRequest(prevState => (
                        {
                            ...prevState,
                            beneficiaryId: response.data.data.benefitId,
                            product: response.data.data.product.productName,
                            productId: response.data.data.product.id
                        }));
                    setSkus(response.data.data.skus)

                    if(response.data.data.skus.length <1)
                        setErrorMessage('Benefício não cadastrado para o produto');
                    

                    setFieldsInvalid(prevState => ({
                        ...prevState,
                        beneficiaryId: false,
                        coupom: false,
                        product: false

                    }));

                } else {
                    if (response.data && response.data.messages && response.data.messages.length > 0)
                        setMessageInvalidCoupon(response.data.messages[0].message)
                    else
                        setMessageInvalidCoupon('Cupom inválido');
                }
            } catch (error) {
                setMessageInvalidCoupon('Erro ao validar cupom');
            } finally {
                setLoadingCoupon(false);
            }
        }
    };

    const validatePerson = async (cpf: string, born: string) => {

        try {
            setLoadingPersonValidation(true);
            setLoading(true);
            setPersonPaciente(prevState => ({
                ...prevState,
                cpf: cpf,
                birthDate: born
            }));

            const isAdultPacientDate = isAdult(request.bornDateMask);

            if (!isAdultPacientDate) {
                setFieldsInvalid(prevState => ({ ...prevState, bornDateMask: false, isValidPerson: false }));
                setErrorMessage('Usuário menor de 18 anos, obrigatório dados de comprador.');
                return;
            }
            
            const dateSplit = born.split("/");
            const dataNascimento = new Date(Number(dateSplit[2]), Number(dateSplit[1]) - 1, Number(dateSplit[0]));
            dataNascimento.setHours(0, 0, 0, 0);

            const baseUrl = window.momentaMaisService.base;
            const verifyPersonUrl = await ConfigService().getConfig(keys.EndpointMomentaMaisPerson);
            const response = await ePharmaServices(baseUrl).get(`${verifyPersonUrl}`, {
                headers: {
                    'cpf': cpf.replace(/\D/g, ""),
                    'dataNascimento': dataNascimento.toUTCString()
                }
            });

            if (response.data && response.data.success)
                setFieldsInvalid(prevState => ({ ...prevState, cpf: false, bornDateMask: false, isValidPerson: false }));

            else {
                setFieldsInvalid(prevState => ({ ...prevState, cpf: true, bornDateMask: true }));
                if (response.data.messages) setErrorMessage(response.data.messages[0].message);
                else setErrorMessage('Verifique os dados CPF e Data nascimento');
                return;
            }
            
        } catch (error) {
            setErrorMessage(prev => prev || 'Erro ao validar CPF ou Data de Nascimento');
        } finally {
            setLoading(false);
            setLoadingPersonValidation(false);
        }
    };
    const validatePersonComprador = async (cpf: string, born: string) => {

        try {

            setLoadingResponsableValidation(true);
            setLoading(true);
            setPersonComprador(prevState => ({
                ...prevState,
                cpf: cpf,
                birthDate: born
            }));
            
            if(born === null){
                const isAdultResponsible = isAdult(born);
                if (!isAdultResponsible) {
                    setErrorMessage(prev => prev || 'O Comprador deve ser maior de 18 anos');
                    return;
                }
            }

            const dateSplit = born.split("/");
            const dataNascimento = new Date(Number(dateSplit[2]), Number(dateSplit[1]) - 1, Number(dateSplit[0]));
            dataNascimento.setHours(0, 0, 0, 0);

            const baseUrl = window.momentaMaisService.base;
            const verifyPersonUrl = await ConfigService().getConfig(keys.EndpointMomentaMaisPerson);
            const response = await ePharmaServices(baseUrl).get(`${verifyPersonUrl}`, {
                headers: {
                    'cpf': cpf.replace(/\D/g, ""),
                    'dataNascimento': dataNascimento.toUTCString()
                }
            });

            if (response.data && response.data.success)
                setFieldsInvalid(prevState => ({ ...prevState, cpfResponsible: false, bornDateMaskResponsible: false, isValidComprador: false }));

            else {
                setFieldsInvalid(prevState => ({ ...prevState, cpfResponsible: true, bornDateMaskResponsible: true }));
                if (response.data.messages) setErrorMessage(response.data.messages[0].message);
                else setErrorMessage('Verifique os dados CPF e Data nascimento');
                return;
            }
            
        } catch (error) {
            setErrorMessage(prev => prev || 'Erro ao validar CPF ou Data de Nascimento');
        } finally {
            setLoading(false);
            setLoadingResponsableValidation(false);
        }
    };


    const checkFormValidity = (): boolean => {
        const allValid = Object.values(fieldsInvalid).every(value => value === false);
        setIsValidForm(allValid);
        return allValid;
    };

    const handleChange = async (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
  
        const { id, type, value } = e.target;
        setErrorMessage("");

        setRequest(prevState => ({
            ...prevState,
            [id]: type === "checkbox" ? ((e.target as HTMLInputElement).checked ? 1 : 0) : value
        }));

        if (id === 'coupom') {
            validateCoupon(value);
        }

        else if (id === 'skuId') {

            setFieldsInvalid(prevState => ({ ...prevState, sku: value === "0" }));
            if (value === "0")
                setErrorMessage('Informe o benefício');

        }

        else if (id === 'cpf') {
            if (!value) {
                setFieldsInvalid(prevState => ({
                    ...prevState,
                    cpf: true,
                    bornDateMask: true,
                    isValidPerson: true,
                    cpfResponsible: false,
                    bornDateMaskResponsible: false,
                    isValidComprador: false
                }));
                setRequest(prevState => ({ ...prevState, bornDateMask: '' }));
                return;
            }

            const isCpfValid = ValidatorService().cpf(value);

            if (!isCpfValid) {
                setErrorMessage('CPF do Paciente inválido');
                return;
            }

            setFieldsInvalid(prevState => ({ ...prevState, cpf: !isCpfValid }));

            let isInvalidPerson = fieldsInvalid.isValidPerson;

            if (value !== personPaciente.cpf || request.bornDateMask !== personPaciente.birthDate)
                isInvalidPerson = true;

            if (!fieldsInvalid.bornDateMask && isInvalidPerson)
                await validatePerson(value, request.bornDateMask);

        }

        else if (id === 'bornDateMask') {
            const isDateValid = ValidatorService().date(value);
            setFieldsInvalid(prevState => ({ ...prevState, bornDateMask: !isDateValid }));

            if (!isDateValid) {
                setErrorMessage(prev => prev || 'Data Nascimento inválido');
                return;
            }

            let isInvalidPerson = fieldsInvalid.isValidPerson;

            const isAdultPacientDate = isAdult(value);
            if (!isAdultPacientDate) {
                setErrorMessage(prev => prev || 'Usuário menor de 18 anos, obrigatório dados de comprador.');
                setFieldsInvalid(prevState => ({ ...prevState, bornDateMask: false, isValidPerson: false }));
                return;
            }

            if (request.cpf !== personPaciente.cpf || value != personPaciente.birthDate)
                isInvalidPerson = true;

            if (!fieldsInvalid.cpf && isInvalidPerson)
                await validatePerson(request.cpf, value);
        }
        else if (id === 'cpfResponsible') {

            const isCpfValid = ValidatorService().cpf(value);

            if (!isCpfValid) {
                setErrorMessage('CPF do Comprador inválido');
                return;
            }

            setFieldsInvalid(prevState => ({ ...prevState, cpfResponsible: false }));

            if (!request.bornDateMaskResponsible)
                setFieldsInvalid(prevState => ({ ...prevState, bornDateMaskResponsible: true, isValidComprador: true }));
           
            let isInvalidPerson = fieldsInvalid.isValidPerson;

            if (value !== personComprador.cpf || request.bornDateMaskResponsible != personComprador.birthDate)
                isInvalidPerson = true;

            if (isInvalidPerson)
                await validatePersonComprador(value, request.bornDateMaskResponsible);
        }
        else if (id === 'bornDateMaskResponsible') {
            if (!value) return;
            const isDataValid = ValidatorService().date(value);

            if (!isDataValid) {
                setErrorMessage(prev => prev || 'Data de nascimento do comprador inválido');
                return;
            }

            if(value !== null || value !== ''){
                const isAdultResponsible = isAdult(value);

                if (!isAdultResponsible) {
                    setErrorMessage(prev => prev || 'O Comprador deve ser maior de 18 anos');
                    return;
                }
            }

            if (!request.cpfResponsible)
                setFieldsInvalid(prevState => ({ ...prevState, cpfResponsible: true, isValidComprador: true }));

            let isInvalidPerson = fieldsInvalid.isValidComprador;

            if (request.cpfResponsible !== personComprador.cpf || value != personComprador.birthDate)
                isInvalidPerson = true;

         
             if (fieldsInvalid.isValidComprador)
                await validatePersonComprador(request.cpfResponsible, value);

             if (!fieldsInvalid.cpfResponsible && !fieldsInvalid.bornDateMaskResponsible) {
                setFieldsInvalid(prevState => ({
                    ...prevState,
                    bornDateMask: false,
                    isValidComprador: false
                }));
                setErrorMessage('');
            }
        }
        else if (id === 'crmState') {

            setFieldsInvalid(prevState => ({ ...prevState, crmState: value === "0" }));
            if (value == "0")
                setErrorMessage('Informe a UF do médico');

        }
        else if (id === 'crmNumber') {

            if (!value)
                setErrorMessage('Informe o CRM do médico');
            else
                setFieldsInvalid(prevState => ({ ...prevState, crmNumber: false }));

        }
        else if (id === 'agreeTerm') {
            const checked = (e.target as HTMLInputElement).checked;
            setFieldsInvalid(prevState => ({ ...prevState, agreeTerm: !checked }));
        }

        checkFormValidity();
    };

    const getState = async () => {

        const baseUrl = await ConfigService().getConfig(keys.ePharmaCommonService);
        const stateUrl = await ConfigService().getConfig(keys.EndpointCommonState);

        const gridParams = {
            page: 1,
            itemsPerPage: 30,
            filter: [],
            sorter: [{ PropertyName: "name", direction: "asc" }]
        };

        const response = await ePharmaServices(baseUrl).get(`${stateUrl}?gridParams=${JSON.stringify(gridParams)}`);

        if (response.data && response.data.success)
            setStates(response.data.data);

        else {
            if (response.data.messages) setErrorMessage(response.data.messages[0].message);
            else setErrorMessage('Erro ao consultar o UF');
        }

    }

    const clearCupom = async () => {
        setRequest(prevState => ({
            ...prevState,
            beneficiaryId: 0,
            coupom: "",
            product: "",
            productId: 0,
            skuId: 0,
            cpf: "",
            crmNumber: "",
            crmState: "0",
            bornDateMask: "",
            bornDate: null,
            cpfResponsible: "",
            bornDateMaskResponsible: "",
            bornDateResponsible: null,
            agreeTerm: 0
        }));

        setSkus([]);
    }
    const submitCoupon = async () => {
    
        setLoading(true);
        setErrorMessage("");
        try {
            const baseUrl = window.momentaMaisService.base;
            const beneficiaryCupomUrl = await ConfigService().getConfig(keys.EndPointMomentaMaisBeneficiaryCupom);

            const formattedRequest = {
                ...request,
                crmNumber: request.crmNumber,
                cpf: request.cpf.replace(/\D/g, ""),
                cpfResponsible: request.cpfResponsible ? request.cpfResponsible.replace(/\D/g, "") : null,
                bornDate: convertStringToDate(request.bornDateMask),
                bornDateResponsible: convertStringToDate(request.bornDateMaskResponsible),
            };

            if(request.bornDateMaskResponsible === null){
                const isAdultPacientDate = isAdult(request.bornDateMask);
                if (isAdultPacientDate) {
                    setErrorMessage('Usuário menor de 18 anos, obrigatório dados de comprador.');
                    return;
                }
            }
            else if(request.bornDateMaskResponsible !== null && request.bornDateMaskResponsible !== ""){
                const isAdultResponsible = isAdult(request.bornDateMaskResponsible);

                if (!isAdultResponsible) {
                    setErrorMessage(prev => prev || 'O Comprador deve ser maior de 18 anos');
                    return;
                }
            }

            const response = await ePharmaServices(baseUrl).post(`${beneficiaryCupomUrl}`, formattedRequest);
            if (!response) {
                setErrorMessage('Não foi possível salvar o Beneficiario');
                return;
            }
            else if (response.data.messages) {
                setErrorMessage(`${response.data.messages[0].message}`);
                return;
            }

            setErrorMessage('');
            setShowSucess(true);
            await clearCupom();

            return null;


        } catch (error) {
            setErrorMessage("Erro ao processar a solicitação. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };


    const getInvalidFieldsMessages = () => {
        const messages = Object.entries(fieldsInvalid)
            .filter(([_, isInvalid]) => isInvalid) // Filtra os campos que estão inválidos
            .map(([field, _]) => errorMessages[field]) // Pega as mensagens de erro correspondentes
            .join("<br />"); // Junta as mensagens com quebra de linha

        setErrorMessage(messages);
    };

    const errorMessages: Record<string, string> = {
        coupom: "O N° do cupom é obrigatório.",
        sku: "O Benefício é obrigatório.",
        cpf: "O CPF do Paciente é obrigatório.",
        bornDateMask: "A Data de nascimento do Paciente é obrigatório.",
        cpfResponsible: "O CPF do comprador é obrigatório.",
        bornDateMaskResponsible: "A Data de nascimento do comprador é obrigatório.",
        crmState: "A UF do Médico é obrigatório.",
        crmNumber: "O CRM do Médico é obrigatório.",
        agreeTerm: "Por Favor aceite o termo."
    };

    const convertStringToDate = (date: string): Date => {
        const dateSplit = date.split("/");
        const dataFormatada = new Date(Number(dateSplit[2]), Number(dateSplit[1]) - 1, Number(dateSplit[0]));
        dataFormatada.setHours(0, 0, 0, 0);
        return dataFormatada;

    }

    return {
        request,
        fieldsInvalid,
        loadingCoupon,
        loadingPersonValidation,
        loadingResponsableValidation,
        messageInvalidCoupon,
        handleChange,
        showSucess,
        setShowSucess,
        loading,
        skus,
        states,
        errorMessage,
        submitCoupon,
        getInvalidFieldsMessages,
        checkFormValidity,
        isSubmitted,
        setIsSubmitted
    };
}